import { z } from 'zod';
import type { BlockDefinition } from '../types';

export const dividerSchema = z.object({
  style: z.enum(['line', 'dots', 'wave', 'space']).default('line'),
  spacing: z.enum(['sm', 'md', 'lg', 'xl']).default('md'),
});

export type DividerData = z.infer<typeof dividerSchema>;

export function DividerRenderer({ style = 'line', spacing = 'md' }: DividerData) {
  return <div className={`v5-divider v5-divider-${style} v5-divider-spacing-${spacing}`} aria-hidden />;
}

export const dividerBlock: BlockDefinition<DividerData> = {
  meta: {
    type: 'divider',
    label: 'Separador',
    description: 'Espacio o línea decorativa entre secciones.',
    category: 'layout',
    icon: 'minus',
  },
  schema: dividerSchema,
  defaults: { style: 'line', spacing: 'md' },
  fields: [
    {
      name: 'style',
      label: 'Estilo',
      type: 'select',
      options: [
        { label: 'Línea', value: 'line' },
        { label: 'Puntos', value: 'dots' },
        { label: 'Onda', value: 'wave' },
        { label: 'Solo espacio', value: 'space' },
      ],
    },
    {
      name: 'spacing',
      label: 'Espaciado',
      type: 'select',
      options: [
        { label: 'Pequeño', value: 'sm' },
        { label: 'Mediano', value: 'md' },
        { label: 'Grande', value: 'lg' },
        { label: 'Extra grande', value: 'xl' },
      ],
    },
  ],
  Renderer: DividerRenderer,
};
